import { create } from 'zustand';

type ToastType = 'success' | 'info' | 'warning' | 'error';
type ToastState = {
  show: boolean;
  message: string;
  type?: ToastType;
  setShow: (payload: { show: boolean; message: string; type?: ToastType }) => void;
};

export const useToastStore = create<ToastState>((set) => ({
  show: false,
  message: '',
  type: 'success',
  setShow: (payload) => set({ ...payload }),
}));
